import angular from 'angular';

class modalContainerUpdateConfirmCtrl {
  /*@ngInject*/
  constructor() {}

  $onInit() {
    this.platformPath = angular.copy(this.resolve.platformPath);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    this.modalInstance.close(true);
  }
}

angular.module('app.principal').component('modalContainerUpdateConfirm', {
  templateUrl: require('./modal-container-update-confirm.html'),
  controller: modalContainerUpdateConfirmCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
